define('SageDotCom/Components/BankFeedModal',["jquery",
    "SageDotCom/Utility/sanitizer"],
    function ($, sanitizer) {
        function BankFeedModal(scope, bankList,
            returnedMessage, expandResultsText, typeAheadMoreResultsText) {
            var allBanks = bankList;
            var $modal = $(".modal", scope);
            var $button = $(".bank-feed-modal-launch");
            var searchButton = $(".bank-feed-modal-search-submit",scope);
            var searchBox = $modal.find("input");
            // set max length for search input field
            searchBox.attr("maxlength", "50");
            var focusableElements;
            var firstElement;
            var lastElement;
            var prevFocusableElement;
            var bankNames = [];

            var $resultsList = $modal.find(".banks-results .banks-results-list");
            var $moreResults = $modal.find(".banks-results .more-results");
            var $showMoreWrapper = $modal.find(".show-more-wrapper");
            var $resultLabel = $modal.find(".bank-result-label");
            var $returned = $modal.find(".returned");
            var $refine = $modal.find(".refine");
            var $resultsWrapper = $modal.find(".banks-results-wrapper");
            var $resultIcon = $resultLabel.find(".icon");
            var $noResultsWrapper = $modal.find(".banks-no-results-wrapper");
            var $showMore = $modal.find(".show-more-banks-result");
            var $searchInput = $modal.find(".bank-feed-modal-search-input");
            var $searchIcon = $modal.find(".search-icon-container");
            var $footNote = $modal.find(".bank-feed-footnote");
            $modal = $modal.detach();
            $('body').append($modal);
            if (allBanks !== null) {
                $.each(allBanks, function (i, bank) {
                    bankNames.push(sanitizer.stripHtml(bank.Name));
                });
            }
            var substringMatcher = function (strs) {
                return function findMatches(q, cb) {
                    var matches, substringRegex;

                    // an array that will be populated with substring matches
                    matches = [];
                  
                    q = q.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
                   
                    substringRegex = new RegExp(q, 'i');
                    // iterate through the pool of strings and for any string that
                    // contains the substring `q`, add it to the `matches` array
                    $.each(strs, function (i, str) {
                        if (substringRegex.test(str)) {
                            matches.push(str);
                        }
                    });

                    cb(matches);
                };
            };
            function ClickHandle() {
                $resultsList.empty();
                $moreResults.empty();
                $showMoreWrapper.addClass("hidden");
                $resultLabel.addClass("hidden");
                $returned.addClass("hidden");
                $refine.addClass("hidden");
                $resultsWrapper.addClass("hidden");
                $resultIcon.removeClass("under-limit");
                var searchStr = $searchInput[0].value;
                var matches = [];

                // regex used to determine if a string contains the substring `q`
                searchStr = searchStr.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

                var substrRegex = new RegExp(searchStr, 'i');
                // iterate through the pool of strings and for any string that
                // contains the substring `q`, add it to the `matches` array
                $.each(bankNames, function(i, bank) {
                        if (bank.match(substrRegex)) {
                            matches.push(bank);
                        }
                    });
                if (matches.length) {

                    $resultsWrapper.removeClass("hidden");
                    $footNote.removeClass("hidden");
                    $resultLabel.removeClass("hidden");
                    $returned.removeClass("hidden");
                    $noResultsWrapper.addClass("hidden");
                    $returned[0].innerText = matches.length + " " + returnedMessage;

                    var limit = matches.length - 1 > 7 ? 7 : matches.length - 1;
                    for (var i = 0; i <= limit; i++) {
                        $resultsList.append('<li class="banks-result"><span>' + matches[i] + '</span></li>');
                    }

                    if (limit === 7) {
                        var more = matches.length - 8;
                        $showMoreWrapper.removeClass("hidden");
                        $showMore[0].text = expandResultsText.replace("{0}", more);
                        $moreResults.addClass("hidden");
                        $refine.removeClass("hidden");
                        for (var j = 8; j <= matches.length - 1; j++) {
                            $moreResults.append('<li class="banks-result"><span>' + matches[j] + '</span></li>');
                        }
                    } else {
                        $resultIcon.addClass("under-limit");
                        $refine.addClass("hidden");
                    }
                } else {
                    
                    $resultsWrapper.addClass("hidden");
                    $footNote.addClass("hidden");
                    $noResultsWrapper.removeClass("hidden");
                }
            }
            searchBox.typeahead({
                hint: false,
                highlight: false,
                minLength: 3
            },
                {
                    name: 'banks',
                    source: substringMatcher(bankNames),
                    limit: 8
                })
                .bind("typeahead:select", function (e, selection) {
                    $(this).typeahead('close');
                    $searchInput[0].value = selection;
                    ClickHandle();
                }).bind('typeahead:render', function (e, datum) {
                    var searchStr = $searchInput[0].value;
                    var matches = [];

                    // regex used to determine if a string contains the substring `q`
                    searchStr = searchStr.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

                    var substrRegex = new RegExp(searchStr, 'i');
                    // iterate through the pool of strings and for any string that
                    // contains the substring `q`, add it to the `matches` array
                    $.each(bankNames,
                        function(i, bank) {

                            if (bank.match(substrRegex)) {
                                matches.push(bank);

                            }
                        });
                    if (matches.length) {
                        var limit = matches.length - 1 > 7 ? 7 : matches.length - 1;
                       
                        if (limit === 7) {
                            var more = matches.length - 8;
                            $modal.find('.tt-dataset.tt-dataset-banks').append('<div class="tt-suggestion bold">' + typeAheadMoreResultsText.replace("{0}", more) + '<div>');
                        }
                    }

                });
            $searchInput.keyup(function (event) {
                // don't do anything if the search term is not entered
                if (event.which === 13 && event.currentTarget.value.length !== 0) {
                    $(this).typeahead('close');
                    ClickHandle();
                }
            });
            $searchIcon.on("click keydown", function (event) {
                if (event.keyCode === 13 || event.type === "click") {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    ClickHandle();
                }
            });
            searchButton.on("click keydown", function (event) {
                if ((event.keyCode === 13 || event.type === "click") && event.currentTarget.value.length !== 0) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    ClickHandle();
                }
            });
            $showMore.on("click", function (event) {
                $moreResults.removeClass("hidden");
                $showMoreWrapper.addClass("hidden");
            });
            let wasClicked = undefined;
            $button.on("click keydown",
                function (e) {
                    if (e.keyCode === 13 || e.type === "click") {
                        e.preventDefault();
                        wasClicked = undefined;
                        prevFocusableElement = document.activeElement;

                        $modal.modal("show");
                        $modal.focus();
                        if (typeof (e.keyCode) === "undefined" && e.type === "click") {
                            wasClicked = true;
                        }
                    }
                       
                    });
           
                    const $close = $(".dismiss, .close", $modal);
                    $close.on("click",
                        function (e) {
                            e.preventDefault();
                            $modal.modal('hide');
                        });
            $modal.on("show.bs.modal", function (e) {
                $modal.attr("aria-hidden", false);
            });
                $modal.on("shown.bs.modal", function (e) {
                    focusableElements = Array.from(e.target.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not(.chrome-ui-button):not(#chrome-url-bar)'));

                    if (focusableElements != null && focusableElements.length > 0) {
                        firstElement = focusableElements[0];
                        lastElement = focusableElements[focusableElements.length - 1];
                    }
                    trapFocus(true, firstElement, lastElement, prevFocusableElement);
                });

                $modal.on("hidden.bs.modal", function (e) {
                    trapFocus(false, firstElement, lastElement, prevFocusableElement);
                    $resultsList.empty();
                    $moreResults.empty();
                    $searchInput[0].value = "";
                    $showMoreWrapper.addClass("hidden");
                    $resultLabel.addClass("hidden");
                    $returned.addClass("hidden");
                    $refine.addClass("hidden");
                    $resultsWrapper.addClass("hidden");
                    $resultIcon.removeClass("under-limit");
                });
            function trapFocus(isModalOpen, firstElement, lastElement, prevFocusableElement) {
            
                    const handleFocus = e => {
                        if (e.keyCode == 9) {
                            if (!e.shiftKey && $(e.target).is(lastElement)) {
                                e.preventDefault();
                                firstElement.focus();
                            } else if (e.shiftKey && $(e.target).is(firstElement)) {
                                e.preventDefault();
                                lastElement.focus();
                            }
                        }
                    };

                if (isModalOpen && typeof (wasClicked) ==="undefined") {
                    firstElement.focus();
                    document.addEventListener("keydown", handleFocus, true);
                }else if (isModalOpen && wasClicked) {
                    $modal.focus();
                    document.addEventListener("keydown", handleFocus, true);
                }else {
                    document.removeEventListener("keydown", handleFocus, true);
                    prevFocusableElement.focus();
                }
            }
        }   

        BankFeedModal.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new BankFeedModal(args.scope, args.bankList,
                    args.returnedMessage, args.expandResultsText, args.typeAheadMoreResultsText);
        };

        return BankFeedModal;
    });

